/*
  Define the different steps that are used throughout the submission process.
 */
export const STEPS: {[step: string]: string} = {
  COMPETITOR: 'competitor',
  ROLE: 'role',
  GUARDIAN: 'guardian',
  ADDRESS: 'address',
  AUTHENTICATION: 'authentication',
  COMPETITOR_ACCOUNT: 'compaccount',
  UPLOAD: 'upload',
  WAIVER: 'waiver',
  CUSTOM_WAIVER: 'custom_waiver',
  COMPLETE: 'complete',
  WITHDRAW: 'withdraw',
};

export const VALIDATION_STEPS: {[step: string]: string[]} = {
  [STEPS.ROLE]: [STEPS.ROLE],
  [STEPS.COMPETITOR]: [STEPS.COMPETITOR],
  [STEPS.ADDRESS]: [STEPS.ADDRESS, STEPS.GUARDIAN],
  [STEPS.AUTHENTICATION]: [STEPS.AUTHENTICATION],
  [STEPS.COMPETITOR_ACCOUNT]: [STEPS.COMPETITOR_ACCOUNT],
  [STEPS.UPLOAD]: [STEPS.UPLOAD, STEPS.WAIVER],
  [STEPS.CUSTOM_WAIVER]: [STEPS.CUSTOM_WAIVER],
}
